export function AppTitle({ title }: { title: string }) {
  const [beforeMark, afterMark] = title.split("!");

  if (!afterMark) {
    return <span>{title}</span>;
  }

  return (
    <>
      <span>{beforeMark.trim()}</span>
      <span className="title-mark" aria-label="!">
        !
      </span>
      <span className="title-suffix">{afterMark.trim()}</span>
    </>
  );
}

export function shortenAccountName(accountName: string) {
  if (!accountName) {
    return "Signed in";
  }

  const [localPart] = accountName.split("@");
  return localPart.length > 12 ? `${localPart.slice(0, 12)}...` : localPart;
}
